import BodyDiagram from './shared/BodyDiagram';
import ExercisesEditor from './shared/ExercisesEditor';

export default function WeightForm({ form, set, records }) {
    const sp = form._sportConfig;
    return (
        <>
            <div className="form-group">
                <label className="form-label">오늘의 목표</label>
                <input
                    className="form-input"
                    placeholder={sp?.focusPlaceholder || '오늘의 목표'}
                    value={form.focus || ''}
                    onChange={e => set('focus', e.target.value)}
                />
            </div>
            <div className="form-group">
                <label className="form-label">운동 목록</label>
                <ExercisesEditor
                    exercises={form.exercises}
                    onChange={val => set('exercises', val)}
                    records={records}
                />
                {form.exercises.some(ex => ex.muscleGroup) && (
                    <BodyDiagram muscles={form.exercises.map(ex => ex.muscleGroup).filter(Boolean)} />
                )}
            </div>
        </>
    );
}
